module.exports = __webpack_public_path__ + "img/phone.5f7fc69d.svg";